

/**
 * Validates whether a given string is a valid email address.
 *
 * @param email - The email address to validate.
 * @returns `true` if the email format is valid, otherwise `false`.
 */
export const isEmailValid = (email: string): boolean => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

/**
 * Validates whether a given string is a valid phone number.
 * 
 * Allows digits, optional leading `+`, spaces, dashes, dots, and parentheses.
 * Length must be between 6 and 20 characters after trimming.
 * 
 * Example valid formats:
 * - +1 123 456 7890
 * - (123) 456-7890
 * - 123-456-7890
 * - 123.456.7890
 * - 1234567890
 * 
 * @param phone - The phone number to validate.
 * @returns `true` if the phone format is valid, otherwise `false`.
 */
export const isPhoneValid = (phone: string): boolean => {
    return /^\+?[0-9\s\-().]{6,20}$/.test(phone.trim());
};


